import { showDeleteConfirmation } from '@modules/common';
import { map, switchMap } from 'rxjs/operators';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { handleMessage, requestMessage } from '@business/messages';
import { OrgBoardAPI } from '@business/api/org_board';
import { OrgBoardResponse, OrgBoardSortResponse, OrgId } from '@business/entities/org_board';

export class OrgBoardChildBloc extends BaseBloc {
  private readonly orgBoardRepo = new Repository<OrgBoardResponse>({
    getItemId: orgBoard => orgBoard.id,
  });

  readonly orgBoard$ = this.orgBoardRepo.items$;
  readonly selectOrgBoard = this.orgBoardRepo.selectItem;

  onReset() {
    this.orgBoardRepo.reset();
  }

  fetchBoard = (id: OrgId) => {
    return OrgBoardAPI.fetchOrgBoardDetails(id).pipe(
      this.orgBoardRepo.ops.reset(),
      //   this.orgBoardRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_org_board_error') }),
    );
  };

  deleteBoard = (orgId: OrgId, typeName: string) => {
    return showDeleteConfirmation(`Delete ${typeName}`, `Do you really want to remove this ${typeName}?`).pipe(
      switchMap(() => OrgBoardAPI.deleteOrgBoard(orgId)),
      //   this.orgBoardRepo.ops.removeOne(() => id),
      this.orgBoardRepo.ops.reset(),
      handleMessage({
        type: requestMessage('delete_org_board'),
      }),
    );
  };

  deleteBoardDetail = (orgId: OrgId, id: OrgId, typeName: string) => {
    return showDeleteConfirmation(`Delete ${typeName}`, `Do you really want to remove this ${typeName}?`).pipe(
      switchMap(() => OrgBoardAPI.deleteOrgBoardDetail(orgId, id)),
      //   this.orgBoardRepo.ops.removeOne(() => id),
      this.orgBoardRepo.ops.reset(),
      handleMessage({
        type: requestMessage('delete_org_board'),
      }),
    );
  };

  createDivisionPositionName = (id: OrgId, orgBoard: Partial<OrgBoardResponse>) => {
    return OrgBoardAPI.createOrgBoardPositionName(id, orgBoard).pipe(
      this.orgBoardRepo.ops.reset(),
      handleMessage({
        type: requestMessage('create_org_board'),
      }),
    );
  };

  deleteBoardPositionName = (orgId: OrgId, id: OrgId, nameIndex: number) => {
    return showDeleteConfirmation('Delete Position Name', 'Do you really want to remove this Position Name?').pipe(
      switchMap(() => OrgBoardAPI.deleteBoardPositionName(orgId, id, nameIndex)),
      //   this.orgBoardRepo.ops.removeOne(() => id),
      this.orgBoardRepo.ops.reset(),
      handleMessage({
        type: requestMessage('delete_org_board_position'),
      }),
    );
  };

  updateSortDetails = (id: OrgId, orgBoard: OrgBoardSortResponse) => {
    return OrgBoardAPI.updateSortDetails(id, orgBoard).pipe(
      this.orgBoardRepo.ops.reset(),
      handleMessage({
        type: requestMessage('update_org_board'),
      }),
    );
  };
  createOrgBoard = (companyId: OrgId, brand: Partial<OrgBoardResponse>) => {
    return OrgBoardAPI.createOrgBoard(companyId, brand).pipe(
      this.orgBoardRepo.ops.reset(),
      //   this.orgBoardRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_org_board'),
      }),
    );
  };

  updateOrgBoard = (id: OrgId, brand: Partial<OrgBoardResponse>) => {
    return OrgBoardAPI.updateOrgBoard(id, brand).pipe(
      //   this.orgBoardRepo.ops.upsertOne(item => ({ item })),
      this.orgBoardRepo.ops.reset(),
      handleMessage({
        type: requestMessage('update_org_board'),
      }),
    );
  };
}
